import { Handle, Position } from "react-flow-renderer"
import "./themeForTippy.css"
import "tippy.js/dist/border.css"
import "tippy.js/animations/scale.css"
import { createUseStyles } from "react-jss"
import { Box, Tooltip } from "@mui/material"
import Right from "../../../icons/correctAdf.svg"
import Wrong from "../../../icons/wrong.svg"
import Inactive from "../../../icons/inactive.svg"
import Inprogress from "../../../icons/inprogress.svg"

const ellipsis = {
  whiteSpace: "nowrap", // Prevent text from wrapping
  overflow: "hidden", // Hide text that overflows
  textOverflow: "ellipsis", // Display an ellipsis (...) when text overflows
}
const useStyles = createUseStyles({
  container: {},
  box: {},
  topBox: { ...ellipsis },
  bottomBox: { ...ellipsis },
  ellipsis,
  img: {
    height: 40,
    position: "relative",
    top: -10,
    left: 11,
  },
})
export function ReactangleNode({ data }: any) {
  const overide = { width: 150, height: 150 }
  const classes = useStyles()
  return (
    <Box sx={overide}>
      <Handle type="target" position={Position.Left} id="rectangle-left" />

      <div className="container">
        <div className="box top-box">
          <Tooltip title={data?.nodeName?.type} placement="top">
            <div className={classes.topBox}>{data?.nodeName?.type}</div>
          </Tooltip>
          <Tooltip
            title={getStatusImg(data.nodeName.run.execution_status).tooltip}
            placement="top"
          >
            <img
              className={`mr-1 ${classes.img}`}
              src={getStatusImg(data.nodeName.run.execution_status).img}
              alt={""}
            />
          </Tooltip>
        </div>
        <div className="box bottom-box">
          <Tooltip title={data?.nodeName?.name} placement="top">
            <div className={classes.bottomBox}>{data?.nodeName?.name}</div>
          </Tooltip>
        </div>
      </div>
      <Handle type="source" position={Position.Right} id="rectangle-right" />
    </Box>
  )
}

const getStatusImg = (status: any) => {
  let statusImg
  switch (status) {
    case 3:
      statusImg = {
        img: Right,
        tooltip: "Completed",
      }
      break
    case 5:
      statusImg = {
        img: Inactive,
        tooltip: "In Active",
      }
      break
    case 1:
      statusImg = {
        img: Inprogress,
        tooltip: "Inprogress",
      }
      break
    default:
      statusImg = {
        img: Wrong,
        tooltip: "Failed",
      }
  }
  return statusImg
}
